import type { CopyShape } from "@tami/core/intl";

import type { NOTES_SCRIPT_COPY_PT_BR } from "../notes-script.copy";

export const NOTES_SCRIPT_COPY_ES_ES: CopyShape<typeof NOTES_SCRIPT_COPY_PT_BR> = {
  notesIntro: {
    narrative:
      "La idea llega en el bus, en la ducha, en mitad de una grabación. Las Notas son donde deja de desaparecer.",
  },
  notesToolbar: {
    narrative: "Escribes y listo: sin carpetas, sin título obligatorio, sin elegir dónde guardar.",
    callout: "\"¿Se te ha ocurrido algo?\" — un clic y la nota ya está abierta.",
  },
  notesList: {
    narrative: "Cada nota tiene un color fijo, así reconoces la que buscas antes de leer el título.",
    callout: "Fija arriba lo que estás usando y el resto baja solo.",
  },
  notesOverview: {
    narrative: "Borrador de guion, gancho de reel, briefing de la marca — todo en el mismo sitio.",
  },
  notesEditor: {
    narrative: "El editor guarda solo mientras escribes. No hay botón de guardar que se te olvide.",
    callout: "La primera línea se convierte en el título, y el resto es solo escribir.",
  },
};
